module.exports = __webpack_public_path__ + "static/media/module_comments.8d5ca05f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_comments.png
// module id = ./src/resources/images/modules/module_comments.png
// module chunks = 0